import { Injectable } from '@angular/core';

@Injectable()
export class AdSHFConfig {
  /**
   * åæ°ï¼é»è®¤ï¼`2`
   */
  col? = 2;
  /**
   * æ ç­¾ææ¬å®½åº¦ï¼åä½ï¼`px`ï¼é»è®¤ï¼`100`
   */
  labelWidth? = 100;
}
